/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable unicorn/consistent-function-scoping */
import LoadingButton from '@mui/lab/LoadingButton/LoadingButton';
import { CircularProgress } from '@mui/material';
import Paper from '@mui/material/Paper/Paper';
import Box from '@mui/material/Box/Box';
import Divider from '@mui/material/Divider/Divider';
import Stack from '@mui/material/Stack/Stack';
import Typography from '@mui/material/Typography/Typography';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { loginStyle } from '../../../styles/container/login';
import { ModalLoginProps } from '../../../types/modal-login';
import { redirectToAzureAd } from '../../../utils/azure-ad';

export function LoginContent({ modalLogin, setModalLogin }: ModalLoginProps) {
  const handleLogin = () => {
    redirectToAzureAd({
      prompt: 'select_account',
      state: { continue: '' },
    });
  };

  return (
    <Stack component="section" sx={loginStyle.contentStack}>
      <Paper variant="outlined" square sx={loginStyle.contentStackPaper}>
          <Stack direction="row" spacing={2}>
            <Box
              component="img"
              src="/assets/logo/logo-pita-biru.svg"
              alt="logo_pita_biru"
            />
            <Box
              component="img"
              src="/assets/logo/logo-binusuniv.svg"
              alt="logo_binus_maya"
            />
          </Stack>
          <Divider sx={loginStyle.contentStackPaperDivider} />
          <Stack direction="column" spacing={2}>
            <Typography variant="caption" sx={loginStyle.contentStackPaperTypography}>
              You need to login using your Binus Account
            </Typography>
            <LoadingButton
              size="large"
              variant="outlined"
              color="secondary"
              loadingIndicator={<CircularProgress sx={{ color: '#5E5E5E' }} size="20px" />}
              sx={loginStyle.contentStackPaperLoginButton}
              onClick={handleLogin}
            >
              <Box
                component="img"
                src="/assets/logo/microsoft.png"
              />
              <Typography
                fontFamily="Open Sans,sans-serif"
                fontSize={16}
                fontWeight={600}
                // fontFamily="Open Sans, sans-serif"
                // fontSize={16}
                // fontWeight={600}
              >
                Sign in with Microsoft
              </Typography>
            </LoadingButton>
          </Stack>
      </Paper>
    </Stack>
  );
}
